// extracted by mini-css-extract-plugin
module.exports = {"right":"right--22Rtx","greeting":"greeting--1vIsZ"};